import axiosClient from '../../configs/axios';


class ProductMasterService {
    // Get list 
    async getProductList(params) {
        try {
            const response = await axiosClient.get(
                `/product/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addProduct(data) {
        try {
            const response = await axiosClient.post('/product/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteProduct(data) {
        try {
            const response = await axiosClient.put(`/product/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ProductMasterService(); 